import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { flatMap } from 'rxjs/operators';
import { getHeaderNew } from '@src/core/base/header';
import { environment } from '@src/environments/environment';
import { DefaultCompanyRepository } from '@src/core/repositories/company/default-company.repository';
import { DefaultCompany, DefaultCompanyRequest } from '@src/core/domain/company/defaultCompany.model';

@Injectable({
  providedIn: 'root',
})
export class DefaultCompanyDataRepository extends DefaultCompanyRepository {

  constructor(private http: HttpClient) {
    super();
  }

  setDefaultCompany(params: DefaultCompanyRequest): Observable<DefaultCompany> {
    const httpOptions = {
      headers: getHeaderNew(),
    };
    return this.http
      .put<DefaultCompany>(
        `${environment.URLBaseV3}admin/cliente-padrao`, 
        params, 
        httpOptions)
      .pipe(flatMap((item) => [item])) 
  } 
}
